import { RapporteringsTyp } from "api/transportDocument.api";
import { NvRapportering } from "./nvRapportering.type";
import { WasteCode } from "./wasteCode.type";
import { AvskiljareTomningType, WasteType } from "./enums";
import { Separator } from "./separator/separator.type";
import { TransportSedel } from "./transportSedel.type";
import { NvRapporteringStatus } from "enums/NvRapporteringStatus.enum";

export type Waste = {
  id: number;
  transportSedel: TransportSedel;
  wasteCode: WasteCode;
  wasteCodeId: number;
  weightPreliminary: string;
  weightFinal: string;
  quantity: string;
  comment: string;
  uuid: string;
  nvRapporteringList: NvRapportering[];
  wasteType: WasteType;
  tomning?: AvskiljareTomning;
  transportRapporteringStatus: NvRapporteringStatus;
  ombudsRapporteringStatus: NvRapporteringStatus;
  transportRapportering?: NvRapportering;
  ombudsRapportering?: NvRapportering;
};

export type AvskiljareTomning = {
  waste: Waste;
  separator: Separator;
  type: AvskiljareTomningType;
};

export type CreateWasteDTO = {
  wasteCodeId: number;
  weightPreliminary?: string;
  quantity?: string;
  comment: string;
};

export const getRelevantWasteWeightToString = (w: Waste) => {
  if (w.weightFinal) {
    return `${w.weightFinal} kg (vägd)`;
  } else if (w.weightPreliminary) {
    return `${w.weightPreliminary} kg (prel)`;
  } else {
    return "";
  }
};

export const getRelevantWasteWeight = (w: Waste) => {
  if (w.weightFinal) {
    return `${w.weightFinal} kg`;
  } else if (w.weightPreliminary) {
    return `${w.weightPreliminary} kg (uppskattat)`;
  } else {
    return "";
  }
};

export const isTransportRapporterad = (w: Waste) =>
  w.nvRapporteringList.some((r) => r.type === RapporteringsTyp.Transport);

export const isTransportPlaneringRapporterad = (w: Waste) =>
  w.nvRapporteringList.some(
    (r) => r.type === RapporteringsTyp.OmbudsRapportering,
  );
